var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-usage"},[_c('report-usages-list',{attrs:{"show-no-energy":"","organization-id":_vm.member.organization.id,"customer-id":_vm.member.customer.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }